import { render, staticRenderFns } from "./Package-data.vue?vue&type=template&id=5a5f3875"
import script from "./Package-data.vue?vue&type=script&lang=js"
export * from "./Package-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports